import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useZonesConfig() {
  const { getZoneConfigs } = useApi();

  const { data, isLoading } = useQuery({
    queryKey: ["zonesConfig"],
    queryFn: () => getZoneConfigs(),
  });

  return { data: data?.data, isLoading };
}
